import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative min-w-full px-4 py-12 mb-16 bg-clay-50" }
const _hoisted_2 = { class: "mx-auto max-w-7xl md:grid md:grid-cols-1 md:gap-x-16 md:gap-y-8 md:px-36" }
const _hoisted_3 = { class: "col-span-1" }
const _hoisted_4 = { class: "relative w-full overflow-visible" }
const _hoisted_5 = {
  key: 0,
  class: "relative overflow-visible"
}
const _hoisted_6 = { class: "flex justify-center w-full overflow-hidden" }
const _hoisted_7 = { class: "flex-shrink-0 w-1/4 px-4" }

import { ref, computed, onMounted, nextTick } from "vue";
import { GetPopularGuidesRequest, GetPopularGuidesResponse, ShowDto } from "@/dtos";
import { client } from "@/shared";
import ShowCard from "../Guides/Shows/ShowCard.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";

const perView    = 4;
const intervalMs = 10000;

export default /*@__PURE__*/_defineComponent({
  __name: 'PopularGuides',
  setup(__props) {

const popularGuides = ref<ShowDto[]>([]);
const track         = ref<HTMLElement|null>(null);
const slideCount    = ref(0);
const active        = ref(0);

const maxActive  = computed(() => Math.max(0, slideCount.value - perView));

function next() {
  const jump = perView;
  const cand = active.value + jump;
  active.value = cand <= maxActive.value ? cand : 0;
}

function prev() {
  const jump = perView;
  const cand = active.value - jump;
  active.value = cand >= 0 ? cand : maxActive.value;
}

async function updateSlideCount() {
  await nextTick();
  if (track.value) slideCount.value = track.value.children.length;
}

onMounted(async () => {
  const resp = await client.get<GetPopularGuidesResponse>(
    new GetPopularGuidesRequest()
  );
  popularGuides.value = resp.shows ?? [];
  await updateSlideCount();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"max-w-6xl min-w-full mx-auto text-center\"><h4 class=\"pr-4 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl\"> Trending <a href=\"/musicals\" class=\"underline hover:text-clay-800 hover:shadow-sm\">Musicals</a>, <a href=\"/plays\" class=\"underline hover:text-clay-800 hover:shadow-sm\">Plays</a> &amp; <a href=\"/operas\" class=\"underline hover:text-clay-800 hover:shadow-sm\">Operas</a></h4><p class=\"pt-2 mb-4 text-xl tracking-tight text-slate-800 sm:text-m lg:text-xl\"> See what shows performers are loving right now. </p></div>", 1)),
          (popularGuides.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    ref_key: "track",
                    ref: track,
                    class: "flex w-full px-2 pb-5 mx-auto transition-transform duration-500 ease-in-out",
                    style: _normalizeStyle(`transform: translateX(-${active.value * (100 / perView)}%)`)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(popularGuides.value, (show) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_openBlock(), _createBlock(ShowCard, {
                          class: "pop-guide-shows",
                          show: show,
                          key: show.id
                        }, null, 8, ["show"]))
                      ]))
                    }), 256))
                  ], 4)
                ]),
                _createElementVNode("button", {
                  onClick: prev,
                  class: "absolute z-20 p-2 transform -translate-y-1/2 bg-white rounded-full shadow -left-6 top-1/2 hover:bg-gray-50"
                }, _cache[0] || (_cache[0] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "w-auto h-8 text-gray-300 hover:text-gray-400",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "stroke-width": "3"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M15 19l-7-7 7-7"
                    })
                  ], -1)
                ])),
                _createElementVNode("button", {
                  onClick: next,
                  class: "absolute z-20 p-2 transform -translate-y-1/2 bg-white rounded-full shadow -right-6 top-1/2 hover:bg-gray-50"
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "w-auto h-8 text-gray-300 hover:text-gray-400",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "stroke-width": "3"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M9 5l7 7-7 7"
                    })
                  ], -1)
                ]))
              ]))
            : (_openBlock(), _createBlock(SkeletonCard, {
                key: 1,
                "card-style": "long",
                "num-of-cards": 4
              }))
        ])
      ])
    ])
  ]))
}
}

})